import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useMounted } from '@/hooks/mounted.hook';
// import AuthCardImg from '@/assets/images/card-auth.png';
// import AuthCardImgLight from '@/assets/images/card-auth-light.png';
import InviteCard from '@/assets/svg/Invite-Card.svg'
import Logo from '@/assets/images/LOGO.png';
import LogoLight from '@/assets/images/logo-light.png';
import ThemeToggle from '@/components/Helper/ThemeToggle';
import { useTheme } from 'next-themes';
import CountUp from 'react-countup';
import GooglePay from '@/assets/svg/icon-GooglePay.svg';
import ApplePay from '@/assets/svg/icon-ApplePay.svg';
import Stripe from '@/assets/svg/icon-stripe.svg';
import Visa from '@/assets/svg/icon-visa.svg';
import GooglePayLight from '@/assets/svg/GooglePay_light.svg';
import ApplePayLight from '@/assets/svg/ApplePay_light.svg';
import StripeLight from '@/assets/svg/Stripe_light.svg';
import VisaLight from '@/assets/svg/Visa_light.svg';

export default function InviteLayout() {
    const mounted = useMounted();
    const { resolvedTheme } = useTheme();
    if (!mounted) {
        return null;
    }

    const iconImages = [
        {
            id: 1,
            iconDark: GooglePay,
            iconLight: GooglePayLight,
        },
        {
            id: 2,
            iconDark: ApplePay,
            iconLight: ApplePayLight,
        },
        {
            id: 3,
            iconDark: Stripe,
            iconLight: StripeLight,
        },
        {
            id: 4,
            iconDark: Visa,
            iconLight: VisaLight,
        },
    ];

    return (
        <div className="flex flex-col bg-no-repeat dark:bg-[#1C1C1E] bg-[#EEEEEE]">
            <main className="min-h-[100dvh] flex relative overflow-hidden">
                <div className="glowBg1 w-[70rem] h-[70rem] bg-[#57E8BAB2] filter blur-[35.5rem] absolute right-[15%] rounded-full bottom-[-50%]"></div>

                <div className="glowBg2 w-[80rem] h-[80rem] bg-[#6AA492B2] filter blur-[35.5rem] absolute left-[-20%] rounded-full top-[75%]"></div>
                <div className="AuthLayout relative 3xl:p-[4rem] p-[2rem] flex flex-col justify-between rounded-[1.5rem] dark:bg-[#161616] bg-[#F9F9F9] mx-[1rem] my-[1rem] lg:mt-[2.5rem] lg:ml-[2.5rem] lg:mb-[2.5rem] lg:mr-0 md:w-full lg:w-[40%] xl:w-[30%] w-[calc(100%-2rem)]">
                    <div className="absolute top-[2rem] right-[2rem]">
                        <ThemeToggle />
                    </div>
                    {/* Logo */}
                    <div className="mr-auto 3xl:mb-12 mb-[1.5rem]">
                        <img
                            src={resolvedTheme === 'dark' ? Logo : LogoLight}
                            alt="nezenx"
                            className="5xl:w-[20rem] w-[15rem] h-auto"
                        />
                    </div>
                    <Suspense fallback={null}>
                        <Outlet />
                        <div className="text-left w-full">
                            <h3 className="dark:bg-gradient-to-r text-center from-white dark:to-[#3B5C52] dark:bg-clip-text dark:text-transparent text-[#000000] font-semibold lg:mb-[1.8rem] mb-[1.5rem] lg:text-[2rem] sm:text-[1.6rem] text-[1.5rem]">
                                Our Partners
                            </h3>
                            <div className="flex flex-wrap 4xl:gap-[6rem] items-center justify-between w-full">
                                {iconImages.map((icon) => {
                                    return (
                                        <div key={icon.id} className='lg:w-auto w-[4.5rem]'>
                                            <img
                                                src={resolvedTheme === 'dark' ? icon.iconDark : icon.iconLight}
                                                alt="icon"
                                                className='w-full h-auto'
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </Suspense>
                </div>
                <div className="flex-1 flex py-[2.5rem] relative z-10 justify-center lgm:block hidden">
                    <div className="layoutContent 3xl:px-[20rem] flex flex-col justify-end gap-[10rem] h-[100%]">
                        {/* <div className="title flex flex-col items-center">
                            <h1 className="font-montserrat text-center text-gradient font-bold text-[3rem] 4xl:text-[4rem] 5xl:text-[6rem] leading-[140%] tracking-[0] capitalize">
                                One platform. <br /> Unlimited cards.
                                <br /> Total control.
                            </h1>
                            <p className="font-montserrat font-medium text-[1.8rem] max-w-[80%] mt-[2rem] leading-[140%] tracking-[0] text-center capitalize">
                                Empower your team with smart virtual accounts and corporate cards built for modern
                                finance.
                            </p>
                        </div> */}

                        <div className="cardImage flex justify-center mt-[2rem]">
                            {resolvedTheme === 'dark' ? (
                                <img src={InviteCard} alt="" className="h-auto 3xl:w-[70%] w-[30rem]" />
                            ) : (
                                <img src={InviteCard} alt="" className="h-auto 3xl:w-[70%] w-[30rem]" />
                            )}
                        </div>

                        <div className="statsCount flex gap-[10rem] justify-center">
                            <div className="users flex flex-col gap-[1.2rem]">
                                <div className="number font-montserrat font-bold text-[4.5rem] dark:text-[#57E8BA] text-black leading-[100%] tracking-[0] capitalize">
                                    <CountUp end={2} duration={3}></CountUp>
                                    <span>M+</span>
                                </div>

                                <div className="title">
                                    <p className="font-montserrat font-normal text-[1.6rem] leading-[100%] tracking-[0] capitalize">
                                        Active Users
                                    </p>
                                </div>
                            </div>

                            <div className="transaction flex flex-col gap-[1.2rem]">
                                <div className="number font-montserrat font-bold text-[4.5rem] dark:text-[#57E8BA] text-black leading-[100%] tracking-[0] capitalize">
                                    <span>$</span>
                                    <CountUp end={50} duration={3}></CountUp>
                                    <span>B</span>
                                </div>

                                <div className="title">
                                    <p className="font-montserrat font-normal text-[1.6rem] leading-[100%] tracking-[0] capitalize">
                                        Transaction
                                    </p>
                                </div>
                            </div>

                            <div className="countries flex flex-col gap-[1.2rem]">
                                <div className="number font-montserrat font-bold text-[4.5rem] dark:text-[#57E8BA] text-black leading-[100%] tracking-[0] capitalize">
                                    <CountUp end={150} duration={3}></CountUp>
                                    <span>+</span>
                                </div>

                                <div className="title">
                                    <p className="font-montserrat font-normal text-[1.6rem] leading-[100%] tracking-[0] capitalize">
                                        Countries
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
